(function() { window.GUID_029e244d_83da_44bc_ae76_f859c6c68686 = { getGuid: function() { return "029e244d-83da-44bc-ae76-f859c6c68686"; } }; })();
var CS;
(function (CS) {
    /**
     * Return a string for the selected User Langue
     * @param English
     * Default string returned if no match
     * @param French
     * French string
     * @param Spanish
     * Spanish string (Espagnol)
     */
    CS.Lang = (English, French, Spanish) => {
        var _a, _b;
        var lang = (_b = (_a = CS.CommonData.Current.Language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "en";
        switch (lang) {
            case "fr":
                if (French)
                    return French;
                break;
            case "es":
                if (Spanish)
                    return Spanish;
                break;
            default:
        }
        return English; //To Check how to do it
    };
    CS.Ress = (params) => {
        var _a, _b;
        const { english, french, spanish } = params;
        var lang = (_b = (_a = CS.CommonData.Current.Language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "en";
        switch (lang) {
            case "fr":
                if (french)
                    return french;
                break;
            case "es":
                if (spanish)
                    return spanish;
                break;
            default:
        }
        return english;
    };
})(CS || (CS = {}));

//# sourceMappingURL=cs-lang.js.map
